import { createColumnHelper } from '@tanstack/react-table';

import { Group } from 'types/groups';
import { convertUTCToLocal } from 'utils/dateUtils';

const col = createColumnHelper<Group>();

export const buildGroupColumns = () => [
  col.accessor((group) => group?.companyName || '-', {
    id: 'companyName',
    header: 'Group Name',
    minSize: 180,
    size: 300,
  }),
  col.accessor((group) => group?.type || '-', {
    id: 'type',
    header: 'Type',
    minSize: 100,
    meta: { align: 'center' },
  }),
  col.accessor(
    (group) => group?.washHub?._id || String(group?.washHub || '-') || '-',
    {
      id: 'washHub',
      header: 'Wash Hub',
      minSize: 200,
      size: 320,
      meta: { align: 'center' },
    },
  ),
  col.accessor((group) => convertUTCToLocal(group?.createdAt, true), {
    id: 'createdAt',
    header: 'Created At',
    minSize: 150,
    meta: { align: 'center' },
  }),
  col.accessor((group) => group?.billingContact || '-', {
    id: 'billingContact',
    header: 'Billing Contact',
    minSize: 150,
    size: 200,
    meta: { align: 'center' },
  }),
];
